import { SELL_API as axios } from '@services/axiosInstance';
import type { ResolvedAddress } from '@t/address.types';
import type {
  AddressPrediction,
  AddressPredictionsParams,
  AddressPredictionsResponse,
  AddressResolutionParams,
} from './addressLookupService.types';

export const ADDRESS_PREDICTIONS_PATH = '/address/predictions';
export const ADDRESS_RESOLUTION_PATH = '/address/resolution';

/**
 * Address suggestions through sell, which holds the provider credential. Nothing
 * authenticating the provider is sent from here, and nothing vendor-shaped comes
 * back.
 */
export const fetchAddressPredictions = async ({
  searchTerm,
  containerId,
  sessionToken,
}: AddressPredictionsParams): Promise<AddressPrediction[]> => {
  const { data } = await axios.get<AddressPredictionsResponse>(ADDRESS_PREDICTIONS_PATH, {
    // An undefined `containerId` is dropped rather than sent empty, so an
    // unscoped search reaches the provider unscoped.
    params: { searchTerm, containerId, sessionToken },
  });
  return data.predictions ?? [];
};

/**
 * The address behind a picked suggestion, already provider-neutral and already in
 * the shape every boundary in this app exchanges — so nothing is mapped here.
 */
export const fetchAddressResolution = async ({
  id,
  sessionToken,
}: AddressResolutionParams): Promise<ResolvedAddress> => {
  const { data } = await axios.get<ResolvedAddress>(ADDRESS_RESOLUTION_PATH, { params: { id, sessionToken } });
  return data;
};
